export const paginationTypes=["pages","loadMore"];